export function patternInputDirective() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, elem, attrs, controller) {
            if (controller) {
                controller.$parsers.push(function (value) {
                    if (new RegExp(attrs.dbmPatternInput, "i").test(value))
                        return value;
                    controller.$setViewValue(controller.$modelValue);
                    controller.$render();
                    return controller.$modelValue;
                });
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/common/directives/dbm-pattern-input.directive.js